export const URL_PREFIX = '/new-design';
export const CLIENT_NAME_DIVIDER = '___';

export const DEBOUNCED_SETS_DATA_DELAY = 750;